import { render, staticRenderFns } from "./VerificationDetailsPEPInfo.vue?vue&type=template&id=840435ce&"
import script from "./VerificationDetailsPEPInfo.vue?vue&type=script&lang=js&"
export * from "./VerificationDetailsPEPInfo.vue?vue&type=script&lang=js&"
import style0 from "./VerificationDetailsPEPInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports